module.exports = __webpack_public_path__ + "img/5.0f9e0bec.jpg";